import React, { Component } from "react";
import EatWithMeText from "../../components/EatWIthMeText";
import { I18n, setLocale, Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import orderListUtil, { deleteOrders, getTable, getTableName, printNewOrders, processAllOrders, toggleSound, update, updateTableOccupations } from "../../js/order-list-util";
import admin, { cancelOrder, getMenuCategory, getMenuItem, getPickupTableNumber, hasRole, lockTable, selectTableNumberSelected, selectTableOccupationSelected, settings, unlockTable } from "../../js/admin";
import { activeMenuCategories, activeMenuItems, decrease, getCrc, getCrc2, getMenuCategoryOptions, increase, payByCardSoftPos, printDailyClosing, submitNewOrders, userChanged } from "../../js/tables-overview";
import auth, { _log, ajaxCallEnd, ajaxCallStart, codepush, decreaseZoom, featureEnabled, get, getGlobal, getInputDialog2, getProxyPercentWidth, getQuantityLabel, increaseZoom, messageDialog, messageDialogTemp, post, setGlobalZoom, startpoll } from "../../js/auth";
import { checkPayments, getCashRegisterOpenCommand, getQrcodeCode, postPayment, printReceipt, reprintReceipts, sendToCashier } from "../../js/tableMatePaid";
import CategoryButton from "./CategoryButton";
import "./kiosk.css";
import MenuItemButton from "./MenuItemButton";
import { store } from "../..";
import EatWithMeActions, { dispatchChangeLanguage } from "../../actions/EatWithMeActions";
import { additionOptionIsChecked, includedInCategoryOption, orderAnother, orderMenuItem } from "../../js/orderMenuItem";
import OrdersByCustomer from "./OrdersByCustomer";
import { allstates, allstates2 } from "../../js/order-grouping";
import InactivityWrapper from "./InactivityWrapper";
import ChangeLanguage from "../../components/icon-buttons/ChangeLanguage";
import { GetInputDialog } from "./getInputDialog";
import { disableZoom, setupZoom } from "../../js/zoom";
import ImageSwitcher from "./ImageSwitcher";
import orderOneItemAudio from "../../audio/orderoneitem.mp3";
import submitOrderAudio from "../../audio/submitorder.mp3";
import { languages_and_countries } from "../../langs/languages";
import { admin_locals, locals } from "../../langs/languages";
import $ from "jquery";
import { XMLParser } from "fast-xml-parser";
import { ThreeSixtyOutlined } from "@material-ui/icons";
import _ from "lodash";
import { generate_nonfiscal_slip_a234, parseCashRegisterStatus_a234 } from "../../js/cashiers/a234";
import { filterForKiosk, getVisibleKioskCategories, isKioskVisibleCategory, isVisibleKioskItem } from "./kioskCategoryVisibility";
import UpsellingSuggestions from "./UpsellingSuggestions";
import upsellService from "../../js/upsellService";

class Kiosk extends Component {
    state = {
        categorySelected: null,
        activeTransitionCategoryId: null,
        activeTransitionVersion: 0,
        timestamp: new Date().getTime(),
        //takeawaySet: false,
        takeawaySet: true,
        selectTakeaway: false,
        cashRegisterDayOpen: undefined,
        showUpselling: false,
        upsellingSuggestions: [],
        upsellMetricsQueue: [], // Queue for tracking metrics
        upsellingSuggestionsShown: false, // Track if suggestions already shown for this cart
        upsellItemsAdded: false // Track if items were added from current upselling session
    };

    constructor(props) {
        super(props);
        this.state.takeawaySet = !props.askTakeaway;
        this.categoryFirstItemRefs = {};
        this.categoryFirstItemRefs2 = {};
        this.categoryRefs = {};
        this.categoriesContainerRef = React.createRef();
        this.menuItemsContainerRef = React.createRef();
        this.wasDisplayingAdScreen = false;
        orderListUtil.ordersCache = [];
        disableZoom();
        auth.zoom = 1;
        setGlobalZoom(1);
        this.resizeBody(); // run on load
        window.addEventListener('resize', this.resizeBody);
        window.addEventListener('load', this.resizeBody);
        this.orderOneItemAudioRef = new Audio(orderOneItemAudio);
        this.submitOrderAudioRef = new Audio(submitOrderAudio);
    }

    resizeBody = () => {
        const baseWidth = 1440;
        const baseHeight = 2580;
        const scale = Math.min(1, window.innerWidth / baseWidth);
        document.body.style.setProperty("--scale", scale);
    }

    componentWillUnmount = () => {
        localStorage.hashBeforeRefresh = "";
        setupZoom();
        this.printReceiptInProgress = false;
        clearInterval(this.cashRegisterDayOpenChecker);
        this.cashRegisterDayOpenChecker = null;
    }

    componentDidMount() {
        //eslint-disable-next-line no-restricted-globals
        localStorage.hashBeforeRefresh = location.hash;
        this.startCategoryTransitionLoop();
        store.dispatch(EatWithMeActions.orders());
        store.dispatch(EatWithMeActions.tableOccupations());
        selectTableNumberSelected(this.props.match.params.tableNumber);
        this.setState({ tableNumber: this.props.match.params.tableNumber, takeawaySet: !this.props.askTakeaway, selectTakeaway: false });
        this.startThisPoll();
        this.printReceiptInProgress = false;

        if (!this.state.categorySelected && this.props.menuCategories && this.props.menuCategories.length > 0) {
            const firstCategory = this.props.menuCategories[0];
            this.setState({ categorySelected: firstCategory.id });
            if (this.menuItemsContainerRef.current) {
                this.menuItemsContainerRef.current.addEventListener("scroll", this.handleScroll);
                this.resync(this.props.match.params.tableNumber);
            }
        }
        orderListUtil.statesShown = allstates2;
        orderListUtil.statesShownOriginal = allstates2;
        orderListUtil.states = ["selected"];
        orderListUtil.props = this.props;
        window.getQuantityLabel = getQuantityLabel;
        window.includedInCategoryOption = includedInCategoryOption;
        window.getMenuCategoryOptions = getMenuCategoryOptions;
        window.getActiveMenuItems = activeMenuItems;
        window.includedInCategoryOption = includedInCategoryOption;
        window.getMenuCategory = getMenuCategory;
        window.increase = increase;
        window.decrease = decrease;
        window.additionOptionIsChecked = additionOptionIsChecked;
        window.admin = admin;
        window.featureEnabled = featureEnabled;

        codepush();
        if (!this.codepush) {
            disableZoom();
            this.codepush = setInterval(codepush, 60000); // every minute  
            try {
                if (window?.KioskPlugin?.isInKiosk)
                    window.KioskPlugin.isInKiosk(function () {
                        _log("Kiosk mode started");
                    }, function (err) {
                        _log("Error starting kiosk: " + err);
                    });
            } catch (ex) {
                _log("Error starting kiosk: " + ex);
            }

        }

    }

    componentDidUpdate() {
        //eslint-disable-next-line no-restricted-globals
        localStorage.hashBeforeRefresh = location.hash;
        this.startCategoryTransitionLoop();
        if (!this.cashRegisterDayOpenChecker && this.props?.myStatus)
            this.startCashRegisterDayOpenChecker();
        if (!this.state.categorySelected && this.props.menuCategories && this.props.menuCategories.length > 0) {
            this.startThisPoll();
            const firstCategory = this.props.menuCategories[0];
            this.setState({ categorySelected: firstCategory.id });
            if (this.menuItemsContainerRef.current) {
                this.menuItemsContainerRef.current.addEventListener("scroll", this.handleScroll);
                this.resync();
            }
        }
        orderListUtil.props = this.props;
        orderListUtil.additionFilter = this.additionFilter;
        if (!this.codepush) {
            disableZoom();
            this.codepush = setInterval(codepush, 60000); // every minute  
            try {
                window.KioskPlugin.isInKiosk(function () {
                    _log("Kiosk mode started");
                }, function (err) {
                    _log("Error starting kiosk: " + err);
                });
            } catch (ex) {
                _log("Error starting kiosk: " + ex);
            }

        }

    }

    componentWillUnmount() {
        orderListUtil.additionFilter = undefined;
        clearInterval(this.cashRegisterDayOpenChecker);
        this.cashRegisterDayOpenChecker = null;
        clearInterval(this.categoryTransitionLoop);
        this.categoryTransitionLoop = null;
        if (this.menuItemsContainerRef.current) {
            this.menuItemsContainerRef.current.removeEventListener("scroll", this.handleScroll);
        }
        clearInterval(this.codepush);
        if (window.KioskPlugin) {
            try {
                _log("Kiosk mode ended ... trying");
                window.KioskPlugin.exitKiosk(function () {
                    _log("Kiosk mode ended");
                }, function (err) {
                    _log("Error ending kiosk: " + err);
                });
            } catch (ex) {
                _log("Error ending kiosk: " + ex);
            }
        }
    }

    categorySelected = (categoryId) => {
        this.setState({ categorySelected: categoryId });
    }

    getEligibleCategories = () => {
        return (this.props.menuCategories || []).filter(category => isKioskVisibleCategory(category));
    }

    getVisibleTransitionCategories = () => {
        const eligibleCategories = this.getEligibleCategories();
        const container = this.categoriesContainerRef?.current;
        const hasMountedRefs = eligibleCategories.some(category => this.categoryRefs[category.id]?.current);

        if (!container || !hasMountedRefs) return eligibleCategories;

        return getVisibleKioskCategories(
            eligibleCategories,
            container.getBoundingClientRect(),
            (category) => this.categoryRefs[category.id]?.current?.getBoundingClientRect?.()
        );
    }

    startCategoryTransitionLoop = () => {
        const visibleCategories = this.getVisibleTransitionCategories();
        if (visibleCategories.length === 0) {
            clearInterval(this.categoryTransitionLoop);
            this.categoryTransitionLoop = null;
            if (this.state.activeTransitionCategoryId) {
                this.setState({ activeTransitionCategoryId: null });
            }
            return;
        }

        if (!this.state.activeTransitionCategoryId || !visibleCategories.some(category => category.id === this.state.activeTransitionCategoryId)) {
            this.setState((prevState) => ({
                activeTransitionCategoryId: visibleCategories[0].id,
                activeTransitionVersion: prevState.activeTransitionVersion + 1
            }));
        }

        if (this.categoryTransitionLoop) return;

        this.categoryTransitionLoop = setInterval(() => {
            this.setState((prevState) => {
                const categories = this.getVisibleTransitionCategories();
                if (categories.length === 0) return null;
                const currentIndex = categories.findIndex(category => category.id === prevState.activeTransitionCategoryId);
                const nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % categories.length;
                const nextCategoryId = categories[nextIndex].id;
                if (prevState.activeTransitionCategoryId === nextCategoryId && categories.length === 1) {
                    return { activeTransitionVersion: prevState.activeTransitionVersion + 1 };
                }
                if (prevState.activeTransitionCategoryId === nextCategoryId) return null;
                return {
                    activeTransitionCategoryId: nextCategoryId,
                    activeTransitionVersion: prevState.activeTransitionVersion + 1
                };
            });
        }, 1000);
    }

    isDisplayingAdScreen = () => {
        return !this.props?.tableOccupation?.id
            && !this.state.errorMessage
            && !this.state.successMessage
            && !this.state.showUpselling
            && !this.state.selectPaymentMethod
            && !this.state.paying;
    }

    resetLanguageToDefault = () => {
        const defaultLanguage = this.props?.myStatus?.restaurant_settings?.["default-language"] || "hu";
        if (this.props.language === defaultLanguage)
            return;

        const defaultCountry = languages_and_countries[defaultLanguage]?.[0] || localStorage.country || "hu";
        this.setLanguage(defaultCountry, defaultLanguage);
    }

    resetMenuScrollPositions = () => {
        if (this.categoriesContainerRef.current) {
            this.categoriesContainerRef.current.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
        if (this.menuItemsContainerRef.current) {
            this.menuItemsContainerRef.current.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
    }

    resetCustomerScreen = () => {
        const displayingAdScreen = this.isDisplayingAdScreen();
        if (!displayingAdScreen || this.wasDisplayingAdScreen) {
            this.wasDisplayingAdScreen = displayingAdScreen;
            return;
        }

        this.resetLanguageToDefault();
        this.resetMenuScrollPositions();

        const firstVisibleCategory = this.getEligibleCategories()[0];
        const firstCategoryId = firstVisibleCategory?.id || null;
        if (this.state.categorySelected !== firstCategoryId) {
            this.setState({ categorySelected: firstCategoryId });
        }

        this.wasDisplayingAdScreen = true;
    }

    render() {
        setTimeout(this.resetCustomerScreen, 100);
        const { myStatus, local } = this.props;
        const { categorySelected } = this.state;
        const visibleCategories = this.getEligibleCategories();
        const statesShown = allstates;
        const paid = this.props?.tableOccupation?.tableMatePayments && this.props.tableOccupation.tableMatePayments[0] && this.props.tableOccupation.tableMatePayments[0].payments && this.props.tableOccupation.tableMatePayments[0].payments[0] && this.props.tableOccupation.tableMatePayments[0].payments[0].done;
        if (myStatus && myStatus.restaurant_id) {
            return (
                <div key="kiosk" id="kiosk" style={{ display: "flex", flexFlow: "column", flexGrow: 1, overflow: "hidden" }}>
                    {this.props.language != this.props.myStatus.restaurant_settings["default-language"] || this.props?.tableOccupation?.id && !this.state.paying ?
                        < InactivityWrapper submitAll={this.submitAll} orderCount={this.props?.orders?.ordersByCustomer?.length} onTimeout={this.cancelAll} timeout={30000} local={local} order={this.state.orderMenuItem} hideOrderMenuItem={this.hideOrderMenuItem} onWarning={() => this.setState({ selectPaymentMethod: false })}>

                        </InactivityWrapper>
                        : null
                    }
                    <div
                        className="menuItemHeader"
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-start",
                            height: "50px",
                            alignItems: "center",
                            fontSize: "18px",
                            backgroundColor: "#FAF8EA",
                            color: "#837B6C",
                            paddingRight: "30px",
                        }}
                    >
                        <EatWithMeText resetMenu={this.resetMenu} />
                        <div style={{ flexGrow: 1 }} />
                        <ChangeLanguage />
                        <audio key="audio1" id="front-desk-bells" src="https://console.eatwithme.online/audio/front-desk-bells.wav" preload="auto"></audio>
                        <audio key="audio2" id="silent" src="https://console.eatwithme.online/audio/silent.wav" preload="auto"></audio>
                    </div>
                    <div key="kioskMain" id="kioskMain" className="kioskMain">
                        {this.state.getPassword ? <GetInputDialog open={true} title={local.pasword} type="password" message={local.password} pattern={/.*/} onClose={this.back} keys={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]} /> : null}
                        {this.state.paying ? this.payingDialog() : null}
                        {this.state.selectPaymentMethod ? this.paymentMethodDialog() : null}
                        {this.state.errorMessage ? this.errorDialog() : null}
                        {this.state.successMessage ? this.successDialog() : null}
                        {this.state.showUpselling ? (
                            <UpsellingSuggestions
                                show={this.state.showUpselling}
                                suggestions={this.state.upsellingSuggestions}
                                menuCategories={this.props.menuCategories || []}
                                language={localStorage.language || 'en'}
                                upsellItemsAdded={this.state.upsellItemsAdded}
                                onAddItems={this.handleAddUpsellItems}
                                onAddItemsComplete={this.closeUpsellingSuggestionsWithoutPayment}
                                onClose={this.closeUpsellingSuggestions}
                                onCancel={this.cancelUpsellingSuggestions}
                            />
                        ) : null}
                        <div key="categories" id="categories" ref={this.categoriesContainerRef} className="kioskCategories">
                            {(visibleCategories && visibleCategories.length > 0) ?
                                visibleCategories.map(category => {
                                    const ref = this.categoryRefs[category.id] = React.createRef();
                                    return (<CategoryButton
                                        key={category.id}
                                        selected={categorySelected == category.id}
                                        myRef={ref}
                                        category={category}
                                        transitionVersion={this.state.activeTransitionVersion}
                                        canTransition={this.state.activeTransitionCategoryId === category.id}
                                        onClick={() => this.scrollToCategory(category.id)} />)
                                }
                                )
                                : null
                            }
                        </div>
                        <div key="rightPart" class="rightPart" onClick={() => { if (this.state.selectTakeaway) this.setState({ selectTakeaway: false, payit: false }) }}>
                            {this.props.orders?.ordersByCustomer?.length ?
                                <div key="cart" className="kioskCart">
                                    {this.props.orders?.ordersByCustomer && this.props.orders.ordersByCustomer.length ?
                                        <div className="kiosk-header">
                                            <div className="kiosk-my-orders"><Translate value="admin_local.myOrders" /></div>
                                            <div className="spacer" />
                                            <div key="kiosk-header-selected-count" className="kiosk-header-selected-count">{String.format(local.selected_items, this.props.orders.ordersByCustomer[0].count)}</div>
                                            <div key="kiosk-header-menuItem-price" className="kiosk-header-menuItem-price">
                                                <div>{this.props.orders.ordersByCustomer[0].price} {myStatus.restaurant_base_currency.name}</div>
                                            </div>
                                        </div> : null}

                                    <div className="kioskButtons">
                                        < div key="takewaySelector" className={(this.state.selectTakeaway ? "force" : "") + " takeawaySelector"}>
                                            <div>
                                                <div onClick={() => this.setTakeAway(false)} class={"localConsumption " + (this.state.takeawaySet && !this.props.tableOccupation?.takeaway ? "selected" : "")} key="localConsumption">{local.localConsumption}</div>
                                                <div onClick={() => this.setTakeAway(true)} class={"takeawayConsumption " + (this.state.takeawaySet && this.props.tableOccupation?.takeaway ? "selected" : "")} key="takeawayConsumption">{local.takeawayConsumption}</div>
                                            </div>
                                        </div>
                                        <div key="selector1" className="selector" />
                                    </div>
                                    {this.props.orders.ordersByCustomer.map(order => <OrdersByCustomer {...order} statesShown={statesShown} cancelOrder={this.cancelOrder} incrementOrder={this.incrementOrder} key={order.customer.id} />)}
                                    <div className="kioskSubmitButtons">
                                        <div key="cancellAll" className="kioskSubmitButton cancellAll" onClick={this.cancelAll}>{local.cancelAll}</div>
                                        <div key="submit" className="kioskSubmitButton submit" onClick={this.payit}>{this.state.paying ? <Translate value="local.payingWithTerminal" /> : paid ? <Translate value="admin_local.payment_successful" /> : <Translate value="local.payit" />}</div>
                                    </div>

                                </div> :
                                this.props?.tableOccupation?.id || this.state.errorMessage || this.state.successMessage ? null : <ImageSwitcher
                                    onClick={this.lockTable}
                                    titleHu={local.kioskOrderHereHu}
                                    titleEn={local.kioskOrderHereEn}
                                    images={[
                                        getProxyPercentWidth(100, auth.server + '/eatwithme.server/tableService/' + localStorage.restaurantSelected + '/getImageByName/kioskImage1?timestamp=' + this.state.timestamp + "&instance=" + localStorage.instance),
                                        // auth.server + '/eatwithme.server/tableService/' + localStorage.restaurantSelected + '/getImageByName/kioskImage2?timestamp=' + this.state.timestamp,
                                        //auth.server + '/eatwithme.server/tableService/' + localStorage.restaurantSelected + '/getImageByName/kioskImage3?timestamp=' + this.state.timestamp,
                                    ]}
                                />
                            }

                            < div key="menuItems" id="menuItems" className="kioskMenuItems" ref={this.menuItemsContainerRef}>
                                {this.props.menuCategories && this.props.menuCategories.length > 0
                                    ? this.props.menuCategories.map((category, categoryIndex) => {
                                        const categoryRef = this.categoryFirstItemRefs[category.id] =
                                            this.categoryFirstItemRefs[category.id] || React.createRef();
                                        const categoryRef2 = this.categoryFirstItemRefs2[category.id] =
                                            this.categoryFirstItemRefs2[category.id] || React.createRef();

                                        return (
                                            <React.Fragment key={category.id}>
                                                <div
                                                    className=""
                                                    index={categoryIndex}
                                                    ref={categoryRef2}
                                                    key={(category.id + "header")}
                                                >
                                                </div>
                                                <div
                                                    className="kioskMenuItemCategoryTitle"
                                                    index={categoryIndex}
                                                    ref={categoryRef}
                                                    key={(category.id + "header2")}
                                                >
                                                    {category.name}
                                                </div>
                                                {category.activeMenuItems.filter(m => isVisibleKioskItem(m)).map((menuItem, index) => (
                                                    <MenuItemButton
                                                        key={menuItem.id}
                                                        menuItem={menuItem}
                                                        category={category}
                                                        index={index}
                                                        onClick={this.orderMenuItem}
                                                    />
                                                ))}
                                            </React.Fragment>
                                        );
                                    })
                                    : null
                                }
                            </div>
                        </div>
                        <div className="bar"></div>
                        <div id="editMenuItemDialog" />
                        <div id="editDiscountDialog" />
                        <div id="markTableMateForPaymentDialog" />
                        <div id="tableMatePaidDialog" />
                        <div id="passwordDialog" />
                    </div >
                </div >
            );
        } else return null;
    }

    scrollToCategory = (categoryId) => {
        this.setState({ scrollingAction: true });
        const buttonInstance = this.categoryFirstItemRefs2[categoryId].current;
        if (buttonInstance) {
            buttonInstance.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', inlineAxis: 'start', blockAxis: 'nearest' });
            setTimeout(() => {
                this.setState({ scrollingAction: false });
            }, 1000);

        }
    }

    handleScroll = () => {
        const container = this.menuItemsContainerRef.current;
        if (!container) return;

        let topCategory = null;
        let minDistance = -Infinity;

        var index = 0;

        Object.entries(this.categoryFirstItemRefs).forEach(([categoryId, ref]) => {
            if (ref?.current) {
                const rect = ref.current.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const distance = rect.top - containerRect.top;
                const index2 = Number(ref.current.getAttribute("index"));


                if (Math.abs(distance) < 10) {
                    minDistance = distance;
                    if (this.categoryRefs[Number(categoryId)]?.current) {
                        //console.log(this.categoryRefs[Number(categoryId)]?.current.getAttribute("name"), index2, distance, index);
                        if (topCategory != Number(categoryId) && index <= index2) {
                            index = index2;
                            topCategory = Number(categoryId);
                            //console.log(">>>", this.categoryRefs[Number(categoryId)]?.current.getAttribute("name"), index2, distance);
                        }
                    }
                }
            }
        });

        if (topCategory && topCategory !== this.state.categorySelected) {
            this.setState({ categorySelected: topCategory });
            if (this.categoryRefs[topCategory]?.current && this.state.scrollingAction !== true) {
                this.categoryRefs[topCategory].current.scrollIntoView({ behavior: 'instant', block: 'nearest' });

                setTimeout(() => {
                    this.categoryRefs[topCategory].current.scrollIntoView({ behavior: 'instant', block: 'nearest' });
                }, 1000);
            }
        }
    };

    getTargetKioskTableNumber = (table) => {
        const candidate = table ?? this.state.tableNumber ?? this.props?.match?.params?.tableNumber;
        const parsed = Number(candidate);
        return Number.isNaN(parsed) ? undefined : parsed;
    }

    isTableOccupationForTable = (tableOccupation, targetTableNumber) => {
        if (!tableOccupation || typeof targetTableNumber === "undefined")
            return false;

        const hasMatchingRestaurantTable = Array.isArray(tableOccupation.restaurantTables) && tableOccupation.restaurantTables.some(rt => {
            const number = Number(rt?.restaurantTable?.number ?? rt?.tableNumber);
            return !Number.isNaN(number) && number === targetTableNumber;
        });

        if (hasMatchingRestaurantTable)
            return true;

        const ownTableNumber = Number(tableOccupation.tableNumber);
        return !Number.isNaN(ownTableNumber) && ownTableNumber === targetTableNumber;
    }

    filterIncomingDataForCurrentTable = (data, table) => {
        if (!data)
            return data;

        const targetTableNumber = this.getTargetKioskTableNumber(table);
        if (typeof targetTableNumber === "undefined")
            return data;

        const sourceTableOccupations = Array.isArray(data.tableOccupations)
            ? data.tableOccupations
            : (data.tableOccupation ? [data.tableOccupation] : []);

        const filteredTableOccupations = sourceTableOccupations.filter(tableOccupation =>
            this.isTableOccupationForTable(tableOccupation, targetTableNumber)
        );

        const tableOccupationIds = new Set(filteredTableOccupations.map(tableOccupation => tableOccupation.id));
        const sourceOrders = Array.isArray(data.orders) ? data.orders : [];
        const filteredOrders = sourceOrders.filter(order => {
            const orderTableNumber = Number(order?.tableNumber);
            if (!Number.isNaN(orderTableNumber) && orderTableNumber === targetTableNumber)
                return true;
            return tableOccupationIds.has(order?.tableOccupationId);
        });

        return {
            ...data,
            tableOccupations: filteredTableOccupations,
            tableOccupation: filteredTableOccupations[0],
            orders: filteredOrders
        };
    }

    resync = (table) => {
        admin.resync([], (data) => {
            const filteredData = this.filterIncomingDataForCurrentTable(data, table);
            const targetTableNumber = this.getTargetKioskTableNumber(table);

            if (typeof targetTableNumber !== "undefined") {
                orderListUtil.tableOccupations = (orderListUtil.tableOccupations || []).filter(tableOccupation =>
                    this.isTableOccupationForTable(tableOccupation, targetTableNumber)
                );
                orderListUtil.ordersCache = (orderListUtil.ordersCache || []).filter(order => {
                    const orderTableNumber = Number(order?.tableNumber);
                    return !Number.isNaN(orderTableNumber) && orderTableNumber === targetTableNumber;
                });
            }

            store.dispatch(EatWithMeActions.menuCategories(filteredData.activeMenuCategories));
            store.dispatch(EatWithMeActions.tableOccupations(filteredData.tableOccupations || []));
            updateTableOccupations(filteredData.tableOccupations || [], filteredData.orders || []);
            this.setState({ timestamp: new Date().getTime() });
            //processAllOrders(data.orders);
            //getTableOccupations(data => {
            try {
                //processTableOccupations(data);
            } finally {
            }
        }, undefined, undefined, table || this.state.tableNumber);

    }

    lockTable = () => {
        this.ensureCashRegisterDayOpen(() => {
            _log("Locking table from kiosk " + !this.props.tableOccupation + " " + this.state.tableNumber);
            if (!getTable(this.state.tableNumber)) {
                this.props.history.push("/kiosks");
                return;
            }
            if (!this.props.tableOccupation) {
                lockTable(this.state.tableNumber, 1, data => {
                    if (data && data.tableOccupations) {
                        updateTableOccupations(data.tableOccupations, data.orders).done(() => {
                            // Reset upselling suggestions flag for new table
                            console.log("[UPSELL] New table locked - resetting suggestions flag");
                            this.setState({
                                takeawaySet: !this.props.askTakeaway,
                                upsellingSuggestionsShown: false // Reset flag for new table
                            });
                            selectTableOccupationSelected(data.tableOccupations[0].id);
                        })
                    }
                })
            }
        });
    }


    orderMenuItem = (menuItem, quantity) => {
        return new Promise((resolve, reject) => {
            if (this.state.paying || this.printReceiptInProgress) {
                reject(new Error("Payment in progress"));
                return;
            }
            this.ensureCashRegisterDayOpen(() => {
                this.playOrderOneItem();
                const { myStatus } = this.props;
                if (!this.props.tableOccupation) {
                    lockTable(this.state.tableNumber, 1, data => {
                        if (data && data.tableOccupations) {
                            updateTableOccupations(data.tableOccupations, data.orders).done(() => {
                                this.setState({ orderMenuItem: true, takeawaySet: !this.props.askTakeaway });
                                orderMenuItem(true, menuItem.entityType, menuItem.id, quantity, false, data.tableOccupations[0].tableMates[0].id, "asap", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false).always(() => {
                                    this.playOrderOneItem();
                                    this.setState({ orderMenuItem: false });
                                    resolve();
                                });
                            });
                        } else {
                            reject(new Error("Failed to lock table"));
                        }
                    });
                    return;
                }
                if (myStatus && myStatus.restaurant_id) {
                    selectTableOccupationSelected(this.props.tableOccupation.id);
                    this.setState({ orderMenuItem: true });
                    // Pass open = false (last parameter) to let orderMenuItem decide if modal is needed
                    // If item has no required options, it will submit directly without showing modal (quickOrder)
                    orderMenuItem(true, menuItem.entityType, menuItem.id, quantity, false, this.props.tableOccupation.tableMates[0].id, "asap", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false).always(() => {
                        this.playOrderOneItem();
                        this.setState({ orderMenuItem: false });
                        resolve();
                    });
                } else {
                    messageDialogTemp(I18n.t("kiosk.error"), I18n.t("kiosk.errorNoRestaurantSelected"));
                    reject(new Error("No restaurant selected"));
                }
            });
        });
    }

    getCashRegisterDayOpenBlockedMessage = () => {
        return I18n.t("admin_local.kiosk_day_open_required");
    }

    setKioskErrorMessage = (message, extraState = {}) => {
        const previousMessage = this.state.errorMessage;
        this.setState({ ...extraState, errorMessage: message });

        if (!message) {
            this.lastSentKioskErrorMessage = null;
            return;
        }

        if (previousMessage === message || this.lastSentKioskErrorMessage === message)
            return;

        this.lastSentKioskErrorMessage = message;
        try {
            const kioskId = this.state?.tableNumber || this.props?.match?.params?.tableNumber || localStorage.cashregister || "";
            const kioskMessage = `Kiosk ${kioskId}: ${String(message).substring(0, 200)}`;
            if (typeof auth?.sendMessage === "function")
                auth.sendMessage("", kioskMessage, "TableOccupation", "1", "message");
        } catch (ex) {
            _log("Failed to send kiosk error message: " + ex);
        }
    }

    getCashRegisterDayNeedsCloseOpenMessage = () => {
        return I18n.t("admin_local.kiosk_day_needs_close_open");
    }

    getCashRegisterCoverOpenMessage = () => {
        return I18n.t("admin_local.printer_errors.cover-open");
    }

    getCashRegisterOutOfPaperMessage = () => {
        return I18n.t("admin_local.printer_errors.out-of-paper");
    }

    showCashRegisterDayOpenBlockedMessage = () => {
        this.setKioskErrorMessage(this.getCashRegisterDayOpenBlockedMessage());
    }

    showCashRegisterDayNeedsCloseOpenMessage = () => {
        this.setKioskErrorMessage(this.getCashRegisterDayNeedsCloseOpenMessage());
    }

    showCashRegisterCoverOpenMessage = () => {
        this.setKioskErrorMessage(this.getCashRegisterCoverOpenMessage());
    }

    showCashRegisterOutOfPaperMessage = () => {
        this.setKioskErrorMessage(this.getCashRegisterOutOfPaperMessage());
    }

    getCashRegisterCommunicationErrorMessage = () => {
        return I18n.t("admin_local.kiosk_cash_register_communication_unsuccessful");
    }

    showCashRegisterCommunicationErrorMessage = (message) => {
        const finalMessage = this.getCashRegisterCommunicationErrorMessage();
        this.setKioskErrorMessage(finalMessage);
        this.cashRegisterCommunicationErrorVisible = true;
    }

    clearCashRegisterErrorMessageIfShown = () => {
        const current = this.state.errorMessage;
        if (!current)
            return;

        const knownCashRegisterErrors = [
            this.getCashRegisterCommunicationErrorMessage(),
            this.getCashRegisterCoverOpenMessage(),
            this.getCashRegisterOutOfPaperMessage(),
            this.getCashRegisterDayNeedsCloseOpenMessage(),
            this.getCashRegisterDayOpenBlockedMessage()
        ];

        if (knownCashRegisterErrors.includes(current)) {
            this.setKioskErrorMessage(null);
        }
    }

    cashRegisterDayOpenChecker = null;

    checkCashRegisterDayOpen = (showBlockedMessage = false) => {
        const previousOpen = this.state.cashRegisterDayOpen;
        this.isCashRegisterDayOpen().done((openResult) => {
            const open = openResult?.open;
            const needsCloseOpen = openResult?.needsCloseOpen;
            const coverOpen = openResult?.coverOpen;
            const outOfPaper = openResult?.outOfPaper;
            this.setState({ cashRegisterDayOpen: open, cashRegisterNeedsCloseOpen: needsCloseOpen, cashRegisterCoverOpen: coverOpen, cashRegisterOutOfPaper: outOfPaper });
            if (open === null) {
                if (showBlockedMessage || previousOpen !== null) {
                    this.showCashRegisterCommunicationErrorMessage(this.lastCashRegisterCommunicationError);
                }
                return;
            }

            if (open && !needsCloseOpen && !coverOpen && !outOfPaper) {
                this.cashRegisterCommunicationErrorVisible = false;
                this.clearCashRegisterErrorMessageIfShown();
                return;
            }

            if (coverOpen) {
                this.showCashRegisterCoverOpenMessage();
                return;
            }

            if (outOfPaper) {
                this.showCashRegisterOutOfPaperMessage();
                return;
            }

            if (this.cashRegisterCommunicationErrorVisible) {
                this.cashRegisterCommunicationErrorVisible = false;
                if (this.state.errorMessage === this.getCashRegisterCommunicationErrorMessage()) {
                    this.setState({ errorMessage: null });
                }
            }

            if (needsCloseOpen) {
                this.showCashRegisterDayNeedsCloseOpenMessage();
                return;
            }

            if (!open && (showBlockedMessage || previousOpen !== false)) {
                this.showCashRegisterDayOpenBlockedMessage();
            }
        });
    }

    startCashRegisterDayOpenChecker = () => {
        if (this.cashRegisterDayOpenChecker)
            return;
        if (!this.props?.myStatus || !Array.isArray(this.props?.myStatus?.restaurant_cash_registers))
            return;
        // Run once when kiosk page opens
        this.checkCashRegisterDayOpen(true);
        // Re-check every minute
        this.cashRegisterDayOpenChecker = setInterval(() => {
            this.checkCashRegisterDayOpen(false);
        }, 60000);
    }

    parseCashRegisterOpenResponse = (data, pattern) => {
        if (typeof data === "boolean")
            return { open: data, coverOpen: false, outOfPaper: false };

        if (typeof data === "string") {
            const statusMatch = data.match(/<Status>([^<]+)<\/Status>/i);
            if (statusMatch) {
                const parsedStatus = parseCashRegisterStatus_a234(statusMatch[1]);
                return { open: parsedStatus.open, needsCloseOpen: parsedStatus.needsCloseOpen, coverOpen: parsedStatus.coverOpen, outOfPaper: parsedStatus.outOfPaper };
            }

            const normalized = data.trim().toLowerCase();
            if (normalized === "true")
                return { open: true, coverOpen: false, outOfPaper: false };
            if (normalized === "false")
                return { open: false, coverOpen: false, outOfPaper: false };
            return { open: pattern ? new RegExp(pattern, "i").test(data) : false, coverOpen: false, outOfPaper: false };
        }

        if (data && typeof data === "object") {
            if (typeof data.error === "string") {
                const err = data.error.toLowerCase();
                if (err.includes("nem válaszol") || err.includes("nem valaszol") || err.includes("not respond") || err.includes("timeout") || err.includes("connection")) {
                    return { open: null, communicationError: data.error };
                }
                return { open: false, coverOpen: false, outOfPaper: false };
            }
            const nestedStatus = data.responses?.[0]?.Response?.Status;
            if (typeof nestedStatus === "string") {
                const parsedStatus = parseCashRegisterStatus_a234(nestedStatus);
                return { open: parsedStatus.open, needsCloseOpen: parsedStatus.needsCloseOpen, coverOpen: parsedStatus.coverOpen, outOfPaper: parsedStatus.outOfPaper };
            }
            if (typeof data.Response?.Status === "string") {
                const parsedStatus = parseCashRegisterStatus_a234(data.Response.Status);
                return { open: parsedStatus.open, needsCloseOpen: parsedStatus.needsCloseOpen, coverOpen: parsedStatus.coverOpen, outOfPaper: parsedStatus.outOfPaper };
            }
            if (typeof data.success === "boolean")
                return { open: data.success, coverOpen: false, outOfPaper: false };
            if (typeof data.success === "string") {
                const normalizedSuccess = data.success.trim().toLowerCase();
                if (normalizedSuccess === "true")
                    return { open: true, coverOpen: false, outOfPaper: false };
                if (normalizedSuccess === "false")
                    return { open: false, coverOpen: false, outOfPaper: false };
            }
            if (typeof data.match === "boolean")
                return { open: data.match, coverOpen: false, outOfPaper: false };
            if (typeof data.result === "boolean")
                return { open: data.result, coverOpen: false, outOfPaper: false };
            if (typeof data.data === "string")
                return { open: pattern ? new RegExp(pattern, "i").test(data.data) : false, coverOpen: false, outOfPaper: false };
            try {
                const serialized = JSON.stringify(data);
                return { open: pattern ? new RegExp(pattern, "i").test(serialized) : false, coverOpen: false, outOfPaper: false };
            } catch (ex) {
                return { open: false, coverOpen: false, outOfPaper: false };
            }
        }

        return { open: false, coverOpen: false, outOfPaper: false };
    }

    isCashRegisterDayOpen = () => {
        const def = new $.Deferred();
        const cashRegisters = this.props?.myStatus?.restaurant_cash_registers || [];
        const c = cashRegisters.find(cr => cr.id === Number(localStorage.cashregister));
        if (!c) {
            def.resolve(true);
            return def.promise();
        }

        const openCommand = getCashRegisterOpenCommand(c);
        if (!openCommand || !openCommand.text) {
            // If a register type has no open-check command, keep ordering unblocked.
            def.resolve({ open: true });
            return def.promise();
        }

        const { text, pattern } = openCommand;

        sendToCashier(c, text, pattern, false,
            (data) => {
                const parsed = this.parseCashRegisterOpenResponse(data, pattern);
                if (parsed.open === null) {
                    this.lastCashRegisterCommunicationError = parsed.communicationError;
                    def.resolve({ open: null, needsCloseOpen: false, coverOpen: false, outOfPaper: false });
                    return;
                }
                this.lastCashRegisterCommunicationError = undefined;
                def.resolve(parsed);
            },
            (err) => {
                this.lastCashRegisterCommunicationError = err?.error || err?.statusText || I18n.t("admin_local.Connection error with the cash register");
                def.resolve({ open: null, needsCloseOpen: false, coverOpen: false, outOfPaper: false });
            }
        );
        return def.promise();
    }

    ensureCashRegisterDayOpen = (onOpen) => {
        this.isCashRegisterDayOpen().done((openResult) => {
            const open = openResult?.open;
            const needsCloseOpen = openResult?.needsCloseOpen;
            const coverOpen = openResult?.coverOpen;
            const outOfPaper = openResult?.outOfPaper;
            this.setState({ cashRegisterDayOpen: open, cashRegisterNeedsCloseOpen: needsCloseOpen, cashRegisterCoverOpen: coverOpen, cashRegisterOutOfPaper: outOfPaper });
            if (coverOpen) {
                this.showCashRegisterCoverOpenMessage();
                return;
            }
            if (outOfPaper) {
                this.showCashRegisterOutOfPaperMessage();
                return;
            }
            if (open) {
                this.cashRegisterCommunicationErrorVisible = false;
                this.clearCashRegisterErrorMessageIfShown();
                onOpen();
            } else if (open === null) {
                this.showCashRegisterCommunicationErrorMessage(this.lastCashRegisterCommunicationError);
            } else if (needsCloseOpen) {
                this.showCashRegisterDayNeedsCloseOpenMessage();
            } else {
                if (this.cashRegisterCommunicationErrorVisible) {
                    this.cashRegisterCommunicationErrorVisible = false;
                    if (this.state.errorMessage === this.getCashRegisterCommunicationErrorMessage()) {
                        this.setState({ errorMessage: null });
                    }
                }
                this.showCashRegisterDayOpenBlockedMessage();
            }
        });
    }

    hideOrderMenuItem = () => {
        this.setState({ getPassword: false });

        // Reset upselling suggestions flag when user manually orders items
        // This allows suggestions to show again if user clicks Pay after adding new items
        this.resetUpsellingSuggestionsFlag();

        setTimeout(() => {
            document.getElementById("close").click();
        }, 100);
    }

    /**
     * Reset upselling suggestions flag when user manually adds items
     * This allows suggestions to be shown again if user clicks Pay after adding new items
     */
    resetUpsellingSuggestionsFlag = () => {
        if (this.state.upsellingSuggestionsShown) {
            console.log("[UPSELL] User added new items manually - resetting suggestions flag");
            this.setState({ upsellingSuggestionsShown: false });
        }
    }

    cancelOrder = (order) => {
        if (this.state.paying || this.printReceiptInProgress)
            return false;
        var data = this.props;
        const paid = data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done;
        if (paid) {
            return false;
        }
        cancelOrder(order, ["selected"], (data) => {
            if (data == null) {
                console.log("Failed to cancel orders");
            } else {
                deleteOrders(data.deletedOrders, true);
                updateTableOccupations([data.tableOccupation], data.orders);
                // tableLayout.updateTableOccupations();
                // updateOrders(data.orders);
            }
        })
    }
    cancelAll = () => {
        if (this.state.paying || this.printReceiptInProgress)
            return false;

        // If upselling suggestions are showing, close them instead of deleting orders
        if (this.state.showUpselling) {
            console.log("[UPSELL] Inactivity timeout - closing upselling suggestions");
            this.cancelUpsellingSuggestions();
            return true;
        }

        var data = this.props;
        const paid = data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done;
        if (paid) {
            return false;
        }

        this.setState({ getPassword: false, selectPaymentMethod: false });

        /*
        if (this.props?.tableOccupation?.id && this.props?.orders && !this.props.orders.ordersByCustomer[0]) {
            return;
        }*/
        if (this.props?.tableOccupation?.id && this.props?.orders && this.props.orders.ordersByCustomer[0] && this.props.orders.ordersByCustomer[0].stateMap.paid > 0) {
            this.submitAll(this.props);
            return true;
        }
        if (this.props?.tableOccupation?.id)
            unlockTable(
                this.props.tableOccupation.id,
                this.state.tableNumber,
                true,
                data => {
                    if (data.tableOccupation) {
                        updateTableOccupations([data.tableOccupation], data.orders);
                        this.setState({ takeawaySet: !this.props.askTakeaway, selectTakeaway: false });
                    }
                },
                data => {
                    auth.ajaxError = false;
                    this.resync(this.state.tableNumber);
                }
            );
        this.setLanguage(languages_and_countries[this.props.myStatus.restaurant_settings["default-language"]][0], this.props.myStatus.restaurant_settings["default-language"] || "hu");
        return true;
    }

    setLanguage(country, language) {
        localStorage.country = country;
        localStorage.language = language;
        let local = locals[language];
        let admin_local = admin_locals[language];
        if (this.props.myStatus)
            auth.get("login/setLanguage/" + language).done(() => {
                // eslint-disable-next-line no-restricted-globals
                this.props.changeLanguage(local, admin_local, language, country);
            });
        // eslint-disable-next-line no-restricted-globals
        else this.props.changeLanguage(local, admin_local, language, country);
        this.setState({ show: false });
        store.dispatch(setLocale(localStorage.language));
        admin.getActiveMenuItems(data => {
            store.dispatch(EatWithMeActions.menuCategories(data.activeMenuCategories));
        });
    }

    incrementOrder = (order) => {
        if (this.state.paying || this.printReceiptInProgress)
            return false;
        var data = this.props;
        const paid = data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done;
        if (paid) {
            return false;
        }

        if (this.state.paying || this.printReceiptInProgress)
            return;
        orderAnother("" + order[0])
    }

    setTakeAway = (takeaway) => {
        if (this.state.paying || this.printReceiptInProgress)
            return;
        const pay = this.state.payit;
        this.setState({ takeawaySet: true, selectTakeaway: false });
        get("adminService/" + this.props.myStatus.restaurant_id + "/setTakeAway/" + this.props.tableOccupation.id + "/" + takeaway).done(data => {
            updateTableOccupations([data.tableOccupation], data.orders);
            if (pay) this.payit();
            this.setState({ takeawaySet: true, selectTakeaway: false, payit: false });
        }).fail(this.errorHandler);
    }

    printReceipt = () => {
        if (this.printReceiptInProgress)
            return;
        this.printReceiptInProgress = true;
        var data = this.props;
        const paid = data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done;
        if (!paid && !this.state.takeawaySet) {
            this.setState({ selectTakeaway: true, payit: true });
            return;
        }
        var c = auth.myStatus.restaurant_cash_registers.find(c => c.id === Number(localStorage.cashregister));
        const tableMatePayment = this.props.tableOccupation.tableMatePayments[0];
        if (!paid)
            this.setState({ paying: true });
        getQrcodeCode(tableMatePayment, true, this.props.tableOccupation.seqnr).done(qr => {
            tableMatePayment.qrcode = qr;
            this.setState({ paying: false });

            if (c.format === "android_http") {
                //format tableMatePayment.id as 0000001
                const tmpid = "" + data.tableOccupation.tableMatePayments[0].id;
                const paddedId = tmpid.padStart(7, '0');
                var commands = qr.split("\r\n").filter(c => c).map(command => "command=" + encodeURIComponent(command.substring(8)).replaceAll("TABLEMATEPAYMENTID", paddedId));
                this.setState({ successMessage: String.format(I18n.t("local.printing_receipt"), data.tableOccupation.seqnr) });
                this.sendToCashRegister(data, commands).done((data) => {
                    this.finish(data)
                }).fail(() => {
                    this.printReceiptInProgress = false;
                });
            } else {
                const tableMatePayments = {
                    id: data.tableOccupation.tableMatePayments[0].id,
                    tableOccupation: data.tableOccupation.id,
                    qrcode: qr
                }
                this.setState({ successMessage: String.format(I18n.t("local.printing_receipt"), data.tableOccupation.seqnr) });
                post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", data.tableOccupation.tableMates.map(m => {
                    m.states.push({ state: "wantsToPay", duration: 0 });
                    return m;
                })).done(() => {
                    postPayment(c, data.tableOccupation.id, [tableMatePayments], true, (data2) => {
                        if (data2.error) {
                            this.setKioskErrorMessage(String.format(I18n.t("local.printing_receipt_error"), data.tableOccupation.seqnr, I18n.t("local." + data2.error)), { payit: false, paying: false });
                            this.printReceiptInProgress = false;
                            return;
                        }
                        if (!data.tableOccupation.tableMatePayments[0].receiptNo && data2.tableOccupation.tableMatePayments[0]?.cashRegister?.format !== "http" && data.tableOccupation.tableMatePayments[0]?.cashRegister?.type !== "a234") {
                            data2.tableOccupation.tableMatePayments[0].receiptNo = "done";
                        }
                        this.finish(data2)
                        this.printReceiptInProgress = false;
                    }, undefined, false, false);
                });
            }


        }).fail(this.errorHandler);

    }

    payit = () => {
        var data = this.props;
        const paid = data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done;
        if (!paid && !this.state.takeawaySet) {
            this.setState({ selectTakeaway: true, payit: true });
            return;
        }

        // Check if upselling feature is enabled before showing suggestions
        if (featureEnabled("kiosk/upsell")) {
            // Show upselling BEFORE payment method selection (not after)
            this.showUpsellingSuggestions();
        } else {
            // Upselling disabled, proceed directly to payment
            this.proceedAfterUpselling();
        }
    }

    /**
     * Called after upselling modal closes
     * Proceeds with payment method selection or direct payment
     */
    proceedAfterUpselling = () => {
        var data = this.props;
        const paid = data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done;

        if (!paid && this.props.cashPaymentTable > 0) {
            this.setState({ selectPaymentMethod: true });
            return;
        }

        // For card payment or if not cash, proceed directly to payment
        this._payitCard();
    }

    /**
     * Show AI-powered upselling suggestions before payment
     * Fetches recommendations based on current cart items
     * Only shows suggestions once per cart state - doesn't show again unless user adds new items
     */
    showUpsellingSuggestions = () => {
        console.log("[UPSELL] Feature enabled - showing upselling suggestions");
        // Skip if we already showed suggestions for this cart
        if (this.state.upsellingSuggestionsShown) {
            console.log("[UPSELL] Suggestions already shown for this cart, proceeding to payment");
            this.proceedAfterUpselling();
            return;
        }

        if (!this.props.orders?.ordersByCustomer || this.props.orders.ordersByCustomer.length === 0) {
            // No items in cart, skip upselling
            console.log("[UPSELL] No cart items, skipping upselling");
            this.proceedAfterUpselling();
            return;
        }

        const cartItems = this.getCartItemsForUpselling();
        const restaurantId = localStorage.restaurantSelected;
        const tableOccupationId = this.props.tableOccupation?.id;
        const language = localStorage.language || 'en';

        console.log("[UPSELL] Showing upselling suggestions for restaurant:", restaurantId);
        console.log("[UPSELL] Cart items:", cartItems);

        // Get AI suggestions
        upsellService.getUpsellingSuggestions(
            cartItems,
            restaurantId,
            tableOccupationId,
            language
        ).done((suggestions) => {
            console.log("[UPSELL] Suggestions resolved:", suggestions);
            if (suggestions && suggestions.length > 0) {
                _log("[UPSELL] Showing modal with " + suggestions.length + " suggestions");
                // Log currency and image for each suggestion
                suggestions.forEach((s, idx) => {
                    console.log(`[UPSELL] Suggestion ${idx + 1}: ${s.name}, Currency: ${s.currency}, Image: ${s.imageUrl?.substring(0, 50)}...`);
                });
                // Show upselling modal and mark suggestions as shown for this cart
                this.setState({
                    showUpselling: true,
                    upsellingSuggestions: suggestions,
                    upsellingSuggestionsShown: true,
                    upsellItemsAdded: false // Reset flag for new upselling session
                });
            } else {
                console.log("[UPSELL] No suggestions received, proceeding with payment");
                // No suggestions, proceed with payment method selection
                this.proceedAfterUpselling();
            }
        }).fail((error) => {
            console.warn("[UPSELL] Failed to fetch upselling suggestions, proceeding with payment", error);
            // On error, proceed with payment method selection anyway
            this.proceedAfterUpselling();
        });
    }

    /**
     * Convert current cart items to format needed for upselling service
     */
    getCartItemsForUpselling = () => {
        const ordersByMenuItem = this.props.orders?.ordersByMenuItem;

        if (!Array.isArray(ordersByMenuItem) || ordersByMenuItem.length === 0) {
            console.log("[UPSELL DEBUG] No ordersByMenuItem array");
            return [];
        }

        const items = [];

        // ordersByMenuItem is an array of menu items
        ordersByMenuItem.forEach(menuItemOrder => {
            if (menuItemOrder && menuItemOrder.menuItem) {
                items.push({
                    id: menuItemOrder.menuItem.id,
                    name: menuItemOrder.comment || menuItemOrder.menuItem.name,
                    price: menuItemOrder.price || 0,
                    quantity: menuItemOrder.quantity || 1,
                    tableNumber: menuItemOrder.tableNumber,
                    menuItem: menuItemOrder
                });
            }
        });

        console.log("[UPSELL DEBUG] Items extracted from ordersByMenuItem:", items);
        return items;
    }

    /**
     * Handle adding upsell items to cart
     */
    handleAddUpsellItems = async (suggestedItems, onComplete) => {
        if (!suggestedItems || suggestedItems.length === 0) {
            if (onComplete) onComplete();
            return;
        }

        // Mark that we're adding items from upselling suggestions
        this.setState({ upsellItemsAdded: true });

        // Add each suggested item to cart sequentially
        for (let index = 0; index < suggestedItems.length; index++) {
            const suggestion = suggestedItems[index];

            // Create menuItem object with all required properties
            const menuItem = suggestion.menuItem || {
                id: suggestion.id,
                name: suggestion.name,
                price: suggestion.price,
                kiosk: true,
                defaultAvailable: true,
                entityType: suggestion.entityType
            };

            // Get quantity from suggestion or default to 1
            const quantity = suggestion.quantity || 1;

            try {
                // Add item to cart using the orderMenuItem method with quantity
                console.log("[UPSELL] Adding item " + (index + 1) + "/" + suggestedItems.length + ":", menuItem.name, "quantity:", quantity);

                // Wait for this item to be added before proceeding to next
                await this.orderMenuItem(menuItem, quantity);

                // Track metric
                const metric = {
                    suggestionId: suggestion.id,
                    menuItemId: suggestion.id,
                    accepted: true,
                    tableOccupationId: this.props.tableOccupation?.id
                };

                this.state.upsellMetricsQueue.push(metric);

                _log("[UPSELL] Item " + (index + 1) + " " + menuItem.name + " added successfully");
            } catch (error) {
                console.error("[UPSELL] Error adding item " + (index + 1) + ":", error);
            }
        }

        // All items added, call onComplete
        if (onComplete) {
            onComplete();
        }
    }

    /**
     * Handle upsell rejection - record metrics and proceed with payment
     */
    handleUpsellRejected = (suggestion) => {
        // Record rejection metric
        const metric = {
            suggestionId: suggestion.id,
            menuItemId: suggestion.id,
            accepted: false,
            tableOccupationId: this.props.tableOccupation?.id
        };

        this.state.upsellMetricsQueue.push(metric);
    }

    /**
     * Close upselling modal and return to main screen after adding items
     * Called after adding suggested items - lets user review cart and order more if desired
     * Does NOT proceed to payment - user must click "Pay" again
     * Keeps upsellingSuggestionsShown flag true so suggestions won't show again for this cart
     */
    closeUpsellingSuggestionsWithoutPayment = () => {
        console.log("[UPSELL] Items added - returning to main screen");
        // Record any pending metrics
        if (this.state.upsellMetricsQueue && this.state.upsellMetricsQueue.length > 0) {
            this.recordUpsellMetrics();
        }

        this.setState({
            showUpselling: false,
            upsellingSuggestions: [],
            upsellMetricsQueue: [],
            payit: false, // Clear payment intent - return to main ordering screen
            selectPaymentMethod: false, // Ensure payment dialog is closed
            paying: false // Cancel any payment in progress
            // Keep upsellingSuggestionsShown: true - don't show suggestions again for this cart
        });
    }

    /**
     * Close upselling modal and proceed with payment method selection
     * Called when user skips suggestions (but is continuing with payment)
     */
    closeUpsellingSuggestions = () => {
        // Record any pending metrics
        if (this.state.upsellMetricsQueue && this.state.upsellMetricsQueue.length > 0) {
            this.recordUpsellMetrics();
        }

        this.setState({
            showUpselling: false,
            upsellingSuggestions: [],
            upsellMetricsQueue: []
        }, () => {
            // Proceed to payment method selection or direct payment
            this.proceedAfterUpselling();
        });
    }

    /**
     * Cancel upselling modal WITHOUT proceeding to payment
     * Called when user clicks Cancel (X button) or clicks outside modal
     * Closes the upselling modal and returns to cart view
     */
    cancelUpsellingSuggestions = () => {
        console.log("[UPSELL] User canceled upselling suggestions - returning to cart");
        this.setState({
            showUpselling: false,
            upsellingSuggestions: [],
            upsellMetricsQueue: [],
            payit: false, // Clear the payment intent flag
            selectPaymentMethod: false, // Ensure payment dialog is closed
            paying: false // Cancel any payment in progress
        });
    }

    /**
     * Send upselling metrics to backend for AI model improvement
     */
    recordUpsellMetrics = () => {
        if (!this.state.upsellMetricsQueue || this.state.upsellMetricsQueue.length === 0) {
            return;
        }

        const restaurantId = localStorage.restaurantSelected;

        this.state.upsellMetricsQueue.forEach(metric => {
            upsellService.recordMetric(
                restaurantId,
                metric.suggestionId,
                metric.menuItemId,
                metric.accepted,
                metric.tableOccupationId
            );
        });
    }

    _payitCard = () => {
        var data = this.props;
        const paid = data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done;
        if (!paid && !this.state.takeawaySet) {
            this.setState({ selectTakeaway: true, payit: true });
            return;
        }
        var c = auth.myStatus.restaurant_cash_registers.find(c => c.id === Number(localStorage.cashregister));
        const tableMatePayment = {
            "tableMate": this.props.tableOccupation.tableMates[0].id,
            "tableOccupation": this.props.tableOccupation.id,
            "orders": this.props.orders.tables[0].orderIds,
            "payments": [
                {
                    "paymentMethod": this.props.myStatus.restaurant_payment_methods.find(m => m.method.name === "Kiosk").method,
                    "amount": this.props.orders.ordersByCustomer[0].price,
                    "currency": "1",
                    "exchangeRate": "1",
                    "cashRegister": c.id,
                    "terminal": localStorage.teya_terminal,
                    "rate": 1,
                    paid: false,
                },
            ],
            "qrcode": "",
            "invoice": false,
            totalAmountPayable: this.props.orders.ordersByCustomer[0].price,

        }
        if (this.state.paying) {
            return;
        }
        if (!paid)
            this.setState({ paying: true }, () =>
                getQrcodeCode(tableMatePayment, true, this.props.tableOccupation.seqnr).done(qr => {
                    //tableMatePayment.qrcode = qr;
                    const tableMateChoices = this.props.tableOccupation.tableMates.map(tm => { return { ...tm, states: [{ state: "wantsToPay", duration: 0 }] } });
                    tableMatePayment.payments.forEach(p => p.paymentMethod = p.paymentMethod.id);
                    post(
                        "adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment",
                        tableMateChoices.map(m => {
                            m.states.push({ state: "wantsToPay", duration: 0 });
                            return m;
                        })
                    ).done(data => {
                        postPayment(c, this.props.tableOccupation.id, [tableMatePayment], false, (data) => {
                            this.setState({ paying: false });
                            if (data.error) {
                                _log("Payment error: " + data.error);
                                this.setKioskErrorMessage(data.error);
                                setTimeout(() => {
                                    this.setKioskErrorMessage(null);
                                }, 10000);
                                return;
                            }
                            this.setState({ successMessage: String.format(I18n.t("local.printing_receipt"), data.tableOccupation.seqnr) });
                            if (c.format === "android_http") {
                                if (this.printReceiptInProgress == true)
                                    return;
                                this.printReceiptInProgress = true;
                                const tmpid = "" + data.tableOccupation.tableMatePayments[0].id;
                                const paddedId = tmpid.padStart(7, '0');

                                var commands = qr.split("\r\n").filter(c => c).map(command => "command=" + encodeURIComponent(command.substring(8)).replaceAll("TABLEMATEPAYMENTID", paddedId));
                                this.sendToCashRegister(data, commands).done((data) => this.finish(data)).fail(() => {
                                    update(data);
                                    this.printReceiptInProgress = false;
                                });
                            } else this.finish(data);

                        }, undefined, false, false, false);
                        update(data);
                    }).fail(this.errorHandler);

                }).fail(data => {
                    this.setState({ paying: false });
                    this.errorHandler(data);
                })
            )

    }

    payitCash = () => {
        const seqnr = this.props.tableOccupation?.seqnr;
        const targetTable = this.props.cashPaymentTable;
        const c = auth.myStatus.restaurant_cash_registers.find(cr => cr.id === Number(localStorage.cashregister));
        submitNewOrders(true, false).done(() => {
            setTimeout(() => {
                if (this.props.tableOccupation?.id) {
                    const doChangeTable = () => {
                        admin.changeToTable(
                            this.props.tableOccupation.id,
                            this.state.tableNumber,
                            targetTable,
                            (data2) => {
                                store.dispatch(EatWithMeActions.tableOccupations([]));
                                store.dispatch(EatWithMeActions.filteredOrders([]));
                                orderListUtil.ordersCache = [];
                                this.playSubmitOrder();
                                this.setState({
                                    successMessage: String.format(I18n.t("local.cashPaymentMessage"), seqnr),
                                    takeawaySet: !this.props.askTakeaway,
                                    selectTakeaway: false
                                });
                                setTimeout(() => {
                                    this.setState({ successMessage: null, errorMessage: null });
                                }, 15000);
                            },
                            this.errorHandler
                        );
                    };

                    if (c && (c.format === "android_http" || c.format === "http" || c.format === "rs232")) {
                        const def = new $.Deferred();
                        const amounts = this._buildAmountsFromOrders();
                        const currencyName = this.props.myStatus?.restaurant_base_currency?.name || "";
                        const payable = this.props.orders?.ordersByCustomer?.[0]?.price || 0;
                        const targetTableName = getTableName(targetTable);
                        generate_nonfiscal_slip_a234(def, seqnr, amounts, payable, currencyName, targetTableName);
                        def.done(slipUrl => {
                            if (c.format === "android_http") {
                                const commands = slipUrl.split("\r\n").filter(cmd => cmd).map(cmd => "command=" + encodeURIComponent(cmd.substring(8)));
                                this.sendNonFiscalToCashRegister(commands).always(doChangeTable);
                            } else {
                                // http / rs232: server-side relay — send entire command string at once
                                sendToCashier(c, slipUrl);
                                doChangeTable();
                            }
                        }).fail(doChangeTable);
                    } else {
                        doChangeTable();
                    }
                }
            }, 100);
        }).fail(this.errorHandler);
    }

    /**
     * Builds an `amounts` object (same structure as used by generate_a234) from
     * the current in-memory orders, grouping items by name.
     */
    _buildAmountsFromOrders = () => {
        const amounts = {};
        let entryOrder = 0;
        const addItem = (name, price, quantity, vat) => {
            if (!amounts[name]) {
                amounts[name] = { name, amount: 0, count: 0, service_amount: 0, vat, entryOrder: entryOrder++ };
            }
            amounts[name].amount += (price || 0) * (quantity || 1);
            amounts[name].count += (quantity || 1);
        };
        (orderListUtil.ordersCache || [])
            .filter(o => o.recordState === "ACTIVE" && o.id > 0)
            .forEach(order => {
                const name = getMenuItem(order.menuItem?.id)?.name || order.menuItem?.name || order.name || "";
                addItem(name, order.price, order.quantity, order.vat);
                (order.childOrders || []).filter(c => c.recordState !== "DELETED").forEach(child => {
                    const childName = (child.addition ? "+" : "-") + (getMenuItem(child.menuItem?.id)?.name || child.menuItem?.name || "");
                    addItem(childName, child.price, child.quantity, child.vat);
                });
            });
        return Object.keys(amounts).length > 0 ? amounts : null;
    }

    /**
     * Sends non-fiscal commands to the a234 via the android HTTP bridge.
     * Unlike sendToCashRegister, this does not track a receipt number and uses
     * simple success/failure handling.
     */
    sendNonFiscalToCashRegister = (commands, def = new $.Deferred()) => {
        if (!commands.length) {
            def.resolve();
            return def.promise();
        }
        const command = commands.shift();
        post("http://127.0.0.1:15000/Request", command, {
            Accept: "gip, deflate",
            "Content-Type": "application/x-www-form-urlencoded",
            UrlEncoded: "1"
        }, false, 0, true, 5000).done(() => {
            if (commands.length > 0)
                this.sendNonFiscalToCashRegister(commands, def);
            else
                def.resolve();
        }).fail(() => {
            // Best-effort: resolve even on print failure so the table move still happens
            def.resolve();
        });
        return def.promise();
    }

    finish = data => {
        /*
        if (data.tableOccupation?.tableMatePayments[0]?.receiptNo) {
            this.props.tableOccupation = data.tableOccupation;
            this.props.orders = data.orders;
        }*/
        update(data);
        this.submitAll(data);
        this.setState({ paying: false, errorMessage: null, successMessage: String.format(I18n.t("local.paymentSuccessMessage"), data.tableOccupation.seqnr) });
        setTimeout(() => {
            this.printReceiptInProgress = false;
            this.setState({ successMessage: null, errorMessage: null });
        }, 15000);
    }

    parser = new XMLParser({
        ignoreAttributes: false, // keep @attributes
        attributeNamePrefix: "_", // prefix for attributes
    });

    sendToCashRegister = (data, commands, def = new $.Deferred(), receiptNo) => {
        const command = commands.shift();
        //setTimeout(() => {
        _log(">" + command);
        //}, 3000);
        try {
            post("http://127.0.0.1:15000/Request", command, {
                Accept: "gip, deflate",
                "Content-Type": "application/x-www-form-urlencoded",
                UrlEncoded: "1"
            }, false, 0, true, 5000).done((xml) => {
                _log(">>" + command);
                try {
                    const data2 = this.parser.parse(xml);
                    //setTimeout(() => {
                    _log(JSON.stringify(data2));
                    //}, 3000);
                    if (data2.Response.Data === "Fiscal Receipt Opened") {
                        commands.splice(0, 0, command);
                        commands.splice(0, 0, "command=celfr\t\r\n");
                        this.sendToCashRegister(data, commands, def);
                        return;
                    }
                    if (data2.Response.Data.RequestLine1 || data2.Response.Data.RequestLine1 === "") {
                        if (data2.Response.Data.RequestLine1?.ReceiptNo)
                            receiptNo = data2.Response.Data.RequestLine1?.ReceiptNo.substring(0, 10)
                        if (commands.length > 0)
                            this.sendToCashRegister(data, commands, def, receiptNo);
                        else {
                            get("adminService/" + localStorage.restaurantSelected + "/updateReceiptNo/" + data.tableOccupation?.id + "/" + data.tableOccupation.tableMatePayments[0]?.id + "/" + receiptNo, undefined, undefined, undefined, false).done((data) => {
                                def.resolve(data);
                            }).fail(() => {
                                def.reject(data);
                            })
                        }
                    } else {
                        def.reject(data);
                        this.setKioskErrorMessage(I18n.t("local.printing_receipt_error") + I18n.t("local." + data2.Response.Data), { payit: false, paying: false });
                    }
                } catch (ex) {
                    _log(">>>" + command);
                    _log("Exception parsing cash register response: " + ex);
                    def.reject(data);
                    update(data);
                    this.setKioskErrorMessage(ex);
                }
            }).fail(data2 => {
                _log(">" + command + " FAILED");
                this.setKioskErrorMessage(I18n.t("admin_local.Connection error with the cash register"));
                setTimeout(() => {
                    def.reject();
                }, 10000);
                //update(data);
            })
        } catch (ex) {
            _log(">>>>>" + command);
            _log("Exception:" + ex);
            this.setKioskErrorMessage(I18n.t("admin_local.Connection error with the cash register"));
            setTimeout(() => {
                def.reject();
            }, 10000);
        }
        return def.promise();
    }


    errorHandler = (err) => {
        this.printReceiptInProgress = false;
        auth.ajaxError = false;
        this.resync(this.state.tableNumber);
        this.setState({ paying: false, successMessage: null, takeawaySet: !this.props.askTakeaway, selectTakeaway: false });
        this.setKioskErrorMessage(typeof err === "string" ? err : (err?.error || err?.statusText || I18n.t("kiosk.error")));
        console.error("Kiosk error: " + JSON.stringify(err));
    }

    submitOrders = () => {
        submitNewOrders(true, false).done(data => {
            setTimeout(() => {
                if (this.props.tableOccupation?.id && this.props.tableOccupation.restaurantTables[0].restaurantTable.number == this.state.tableNumber)
                    admin.changeToTable(this.props.tableOccupation.id, this.state.tableNumber, this.getTargetTableNumber(), (data2) => {
                        if (this.props.tableOccupation?.id) {
                            if (this.props.tableOccupation?.id && this.props.tableOccupation.restaurantTables[0].restaurantTable.number == this.state.tableNumber) {
                                update(data2);
                                post("printerServerClient/" + localStorage.restaurantSelected + "/printKitchenReceipt2/" + this.props.tableOccupation.id + "/" + this.getTargetTableNumber(),
                                    { "untilTiming": "last", "printerOptions": [], "reprint": false },
                                    undefined, false, 0, true)
                                    .done(() => {
                                        store.dispatch(EatWithMeActions.tableOccupations([]));
                                        store.dispatch(EatWithMeActions.filteredOrders([]));
                                        orderListUtil.ordersCache = [];
                                        this.playSubmitOrder();
                                        //this.resync(this.state.tableNumber);
                                        if (data?.tableOccupation?.seqnr) {
                                            this.setState({ successMessage: String.format(I18n.t("local.paymentSuccessMessage"), data.tableOccupation.seqnr), takeawaySet: !this.props.askTakeaway, selectTakeaway: false });
                                            setTimeout(() => {
                                                this.setState({ successMessage: null, errorMessage: null });
                                            }, 15000);
                                        } else {
                                            this.setState({ successMessage: null, takeawaySet: !this.props.askTakeaway, selectTakeaway: false });
                                        }

                                    }).fail(this.errorHandler);
                                /*
                                printNewOrders(orderListUtil.ordersCache, undefined, undefined, true).done((data) => {
                                    store.dispatch(EatWithMeActions.tableOccupations([]));
                                    store.dispatch(EatWithMeActions.filteredOrders([]));
                                    orderListUtil.ordersCache = [];
                                    this.playSubmitOrder();
                                    //this.resync(this.state.tableNumber);
                                    this.setState({ successMessage: I18n.t("local.paymentSuccessMessage") });
                                    setTimeout(() => {
                                        this.setState({ successMessage: null });
                                    }, 5000);
                                }).fail(this.errorHandler);
                                */
                            }
                        }
                    }, this.errorHandler);
            }, 100);
        }).fail(this.errorHandler);
    }


    submitAll = (data) => {
        if (!data) data = this.props;
        if (data && data?.tableOccupation?.tableMatePayments && data.tableOccupation.tableMatePayments[0] && data.tableOccupation.tableMatePayments[0].payments && data.tableOccupation.tableMatePayments[0].payments[0] && data.tableOccupation.tableMatePayments[0].payments[0].done) {
            if (!data.tableOccupation.tableMatePayments[0].receiptNo && !this.props.tableOccupation.tableMatePayments[0].receiptNo) {
                this.printReceipt();
                return;
            }
            //this.setState({ successMessage: String.format(I18n.t("local.paymentSuccessMessage"), data.tableOccupation.seqnr) });
            setTimeout(() => {
                if (data.tableOccupation.bookedProperties && data.tableOccupation.bookedProperties["thirdparty-order-number"]) {
                    this.submitOrders();
                    return;
                }
                var bookedProperties = { "thirdparty-order-number": "kiosk " + this.props.tableOccupation.seqnr };
                post("adminService/" + localStorage.restaurantSelected + "/updateBooking/" + this.props.tableOccupation.id, bookedProperties).done((data2) => {
                    setTimeout(() => {
                        if (this.props?.tableOccupation?.id && !(this.props?.tableOccupation?.bookedProperties && this.props.tableOccupation.bookedProperties["thirdparty-order-number"])) {
                            update(data2);
                        }
                        if (this.props?.tableOccupation?.id)
                            this.submitOrders();
                    });
                }).fail(this.errorHandler);
            }, 100);
        }
    }

    payingDialog = () => {
        //Generate a message asking the client to pay with the terminal attached
        const { local } = this.props;
        return (
            <div className="kioskDialogCover">
                <div className="kioskDialog">
                    <div className="kioskDialogContent">
                        <Translate value="local.payingWithTerminal" />
                    </div>
                </div>
            </div>
        );
    }

    errorDialog = () => {
        return (
            <div className="kioskDialogCover">
                <div className="kioskDialog errorDialog" onClick={this.resetMenu}>
                    <div className="kioskDialogContent">
                        {this.state.errorMessage}
                    </div>
                </div>
            </div>
        );
    }
    successDialog = () => {
        return (
            <div className="kioskDialogCover">
                <div className="kioskDialog successDialog">
                    <div className="kioskDialogContent">
                        {this.state.successMessage}
                    </div>
                </div>
            </div>
        );
    }

    paymentMethodDialog = () => {
        const { local } = this.props;
        return (
            <div className="kioskDialogCover">
                <div className="kioskDialog paymentMethodDialog">
                    <div className="kioskDialogContent">
                        {I18n.t("local.selectPaymentMethod")}
                    </div>
                    <div className="kioskDialogFooter paymentMethodFooter">
                        <button className="payBtn payBtn--card" onClick={() => { this.setState({ selectPaymentMethod: false }); this._payitCard(); }}>
                            <span className="payBtn__icon icon-credit-card"></span>
                            <span className="payBtn__label">{I18n.t("local.payCard")}</span>
                        </button>
                        <button className="payBtn payBtn--cash" onClick={() => { this.setState({ selectPaymentMethod: false }); this.payitCash(); }}>
                            <span className="payBtn__icon icon-dollar"></span>
                            <span className="payBtn__label">{I18n.t("local.payCash")}</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    resetMenu = async (event) => {
        event.stopPropagation();
        event.preventDefault();

        this.setState({ getPassword: true })
    };

    startThisPoll = () => {
        if (this?.props?.myStatus?.sessionId)
            startpoll(this.messageHandler, [
                {
                    Restaurant: localStorage.restaurantSelected,
                    TableOccupation: "*",
                    TableNumber: this.state.tableNumber
                },
                {
                    Restaurant: localStorage.restaurantSelected,
                    Menu: "*"
                },
                {
                    Restaurant: localStorage.restaurantSelected,
                    Settings: "*"
                },
                {
                    Restaurant: localStorage.restaurantSelected,
                    Printer: "*"
                }
            ], undefined, this.resync, this.props.myStatus.sessionId);
    }

    crcErrorCount = 0

    messageHandler = (message) => {
        if (message.type == "timeout" && message.message == "true") {
            const crcs = orderListUtil.ordersCache.filter(o => o.recordState == "ACTIVE" && o.id > 0).sort((a, b) => a.id - b.id).map(o => {
                const t = allstates2.indexOf(o.originalState || o.state);
                return t >= 0 ? [o.id, t] : null;
            });
            if (message.crc2 !== undefined) {
                const crc = getCrc();
                const crc2 = getCrc2();
                if (message.crc2 !== crc2) {
                    //console.log(crcs);

                    // console.log("crc " + message.crc + "/" + message.crc2);
                    if (this.crcErrorCount && this.prevCrc2 != message.crc2) {
                        //post("restaurantService/" + localStorage.restaurantSelected + "/logOrderDifference", crcs, undefined, false, 0, true).fail(() => auth.ajaxError = false);
                        console.error("crc error localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2 + " new Orders:" + orderListUtil.newOrders.length);
                        this.prevCrc2 = message.crc2;
                    }
                    if (this.crcErrorCount++ > 5) {
                        if (crc > message.crc)
                            console.error("crc error (" + this.crcErrorCount + ") ahead localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2);
                        else
                            console.error("crc error (" + this.crcErrorCount + ") behind localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2);
                        this.crcErrorCount = 0;
                        this.resync();
                        return;
                    }
                } else {
                    if (this.prevCrc2 != message.crc2) {
                        //console.log("crc ok localOrderCount=" + crc2 + "/" + crc + " serverOrderCount=" + message.crc + "/" + message.crc2);
                        this.prevCrc2 = message.crc2;
                    }
                    if (this.crcErrorCount) { //crc is ok 
                        if (this.crcErrorCount++ > 1) {
                            console.error("crc ok (" + this.crcErrorCount + ") localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2);
                        }
                        this.crcErrorCount = 0;
                    }
                }
            }
            return;
        } else if (message.type == "refresh" && message.message == "menu changed") {
            this.resync(this.state.tableNumber);
        } else if (message.type == "reloadKiosks") {
            _log("KIOSK: Refreshing due to superadmin request");
            setTimeout(() => {
                //eslint-disable-next-line
                location.reload();
            }, 1000);
        } else if (message.type == "reload") {
            _log("LOGIN: Reloading due to server request");
            setTimeout(() => {
                //eslint-disable-next-line
                location.reload();
            }, 1000);
        }
        if (message?.data) {
            const filteredData = this.filterIncomingDataForCurrentTable(message.data, this.state.tableNumber);
            update(filteredData);
        }
    }

    back = (password) => {
        if (password) {
            get("login/changeSession?user=" + this.props.myStatus.id + "&quickCode=" + password).done(data => {
                if (!data.error)
                    this.props.history.push("/kiosks");
            });
            /*
            post( "/eatwithme.server/login?instance=eatwithme", "username=" + encodeURIComponent(this.props.myStatus.email.toLowerCase()) + "&password=" + encodeURIComponent(password) + "&redirect=true&keep=true", {}
            )
                .fail(data => {
                    auth.ajaxError = false;
                })
                .done(() => {
                    this.props.history.goBack();
                });*/
        } else {
            this.setState({ getPassword: false });
        }
    }

    additionFilter = (additionOption) => {
        if (additionOption.type === "meal_addition" || additionOption.type === "drink_addition") {
            const m = getMenuItem(additionOption.addition.id);
            return m?.defaultKiosk && m?.kiosk && m?.defaultAvailable;
        } else if (additionOption.type === "mealcategory_addition" || additionOption.type === "drinkcategory_addition") {
            const m = getMenuCategory(additionOption.addition.id);
            return m?.defaultKiosk && m?.kiosk && m?.defaultAvailable;
        } else if (additionOption.type === "meal" || additionOption.type === "drink") {
            return additionOption?.defaultKiosk && additionOption?.kiosk && additionOption?.defaultAvailable;
        } else if (additionOption.type === "meal_category" || additionOption.type === "drink_category") {
            return additionOption?.defaultKiosk && additionOption?.kiosk && additionOption?.defaultAvailable;
        } else if (additionOption?.settings?.kiosk?.kiosk?.enabled === false) {
            return false;
        }
        return true;
    }

    playOrderOneItem = () => {
        this.orderOneItemAudioRef.currentTime = 0; // újrajátszás elejétől
        this.orderOneItemAudioRef.play();
    }
    playSubmitOrder = () => {
        this.submitOrderAudioRef.currentTime = 0; // újrajátszás elejétől
        this.submitOrderAudioRef.play();
    }

    getTargetTableNumber = () => {
        if (this.props?.tableOccupation?.takeaway || this.props.localConsumptionTable == 0) {
            return getPickupTableNumber();
        }
        return this.props.localConsumptionTable;
    }


}

const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            menuCategories: props.rootReducer.menuCategories ? filterForKiosk(props.rootReducer.menuCategories) : [],
            orders: props.rootReducer.filteredOrders,
            tableOccupation: props.rootReducer.tableOccupations?.length > 0 ? props.rootReducer.tableOccupations[0] : undefined,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
            tables: props.rootReducer.tables,
            language: props.rootReducer.language,
            askTakeaway: props.rootReducer.myStatus.restaurant_settings?.["enabled-features"]?.kiosk?.askTakeaway || false,
            localConsumptionTable: props.rootReducer.myStatus.restaurant_settings?.["enabled-features"]?.kiosk?.localConsumptionTable || 0,
            cashPaymentTable: props.rootReducer.myStatus.restaurant_settings?.["enabled-features"]?.kiosk?.cashPaymentTable || 0,
            deliveryUsers: [],
        };
    }
    return {};
};


const mapDispatchToProps = dispatch => {
    return {
        changeLanguage: dispatchChangeLanguage(dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Kiosk);
